import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const locationExtension = {
  url: 'http://narus.com/fhir/StructureDefinition/goal-location'
}

const isAssistanceNeededExtension = {
  url: 'http://narus.com/fhir/StructureDefinition/goal-isAssistanceNeeded'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Goal'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'status' ],
    fhir_const: 'planned'
  },
  {
    fhir: [ 'category' ],
    fhir_const: [
      {
        coding: [
          {
            system: 'http://snomed.info/sct',
            code: '160786009',
            display: 'Personal milestones (observable entity)'
          }
        ],
        text: 'Personal milestones (observable entity)'
      }
    ]
  },
  {
    fhir: [ 'description', 'text' ],
    form: [ 'goal' ]
  },
  {
    fhir: [ 'targetDate' ],
    form: [ 'date' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'startDate' ],
    form: [ 'startDate' ],
    to_fhir: form2fhir
  },

  {
    fhir: [ 'statusDate' ],
    form: [ 'statusDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'note', 0, 'text' ],
    form: [ 'comments' ]
  },
  {
    fhir: [ 'extension', locationExtension, 'valueReference', 'display' ],
    form: [ 'location' ]
  },
  {
    fhir: [ 'extension', isAssistanceNeededExtension, 'valueString' ],
    form: [ 'needsHelp' ]
  }
]

export const mapGoal = (patientId, form) => {
  const resource = transform(form, mapping, [ 'form', 'fhir' ])
  resource.subject = { reference: `Patient/${patientId}` }
  resource.startDate = resource.startDate || new Date()
  resource.statusDate = resource.statusDate || new Date()
  return resource
}

export const unmapGoal = data => transform(data, mapping, [ 'fhir', 'form' ])
